const React = require("react");
const handleLabel = require("../../utils/handleLabel");

module.exports = ({id, label, isRequired}) => label ? (
  <label
    htmlFor={id}
    className="dB c0 f12 h12 lh lts0em fw4 mb14 ff$3"
  >
    {handleLabel({label, isRequired})}
  </label>
) : null;
